import type { EventRow, EventType } from '../api/model';
import { formatDecimal, negateDecimal } from './decimal';

export const TYPE_LABEL: Record<EventType, string> = {
  borrow: 'Hitelfelvétel',
  repay: 'Visszafizetés',
  buy: 'Vétel',
  sell: 'Eladás',
  interest: 'Kamat (számolt)',
  transfer: 'Transzfer',
  liquidation: 'Kényszerlikvidálás',
  balance_snapshot: 'Egyenleg-rögzítés',
  result: 'Eredmény',
};

/** "Eladás BTC → USDT", "Transzfer"... the type column of event tables. */
export function eventTypeText(e: Pick<EventRow, 'type' | 'asset' | 'quote_asset'>): string {
  const base = TYPE_LABEL[e.type];
  if ((e.type === 'buy' || e.type === 'sell' || e.type === 'liquidation') && e.quote_asset) {
    return e.type === 'buy' ? `${base} ${e.quote_asset} → ${e.asset}` : `${base} ${e.asset} → ${e.quote_asset}`;
  }
  if (e.type === 'buy' || e.type === 'sell') return `${base} ${e.asset}`;
  return base;
}

export function locationText(e: Pick<EventRow, 'location' | 'counter_location' | 'type'>): string {
  return e.type === 'transfer' && e.counter_location ? `${e.location} → ${e.counter_location}` : e.location;
}

/** Signed display quantity: sells and repayments leave the location. */
export function signedQuantityText(e: Pick<EventRow, 'type' | 'quantity' | 'asset'>): string {
  const out = e.type === 'sell' || e.type === 'repay' || e.type === 'liquidation';
  const plus = e.type === 'borrow' || e.type === 'buy';
  const q = out ? negateDecimal(e.quantity) : e.quantity;
  return `${formatDecimal(q, { sign: plus })} ${e.asset}`;
}

/** Numeric sort value for the quantity column (raw decimal string, signed). */
export function signedQuantityValue(e: Pick<EventRow, 'type' | 'quantity'>): string {
  const out = e.type === 'sell' || e.type === 'repay' || e.type === 'liquidation';
  return out ? negateDecimal(e.quantity) : e.quantity;
}

export const SOURCE_LABEL = { binance: 'Binance', manual: 'Kézi', calculated: 'Számolt' } as const;
